const servicesData = [
  {
    id: 1,
    title: "Roof Replacement",
    description:
      "Complete roof replacement with premium materials and warranty-backed installation.",
    icon:
      "https://images.unsplash.com/photo-1610864903031-140bb361f5f6?auto=format&fit=crop&w=80",
  },
  {
    id: 2,
    title: "Roof Repair",
    description:
      "Leak repairs, storm damage fixes, and weatherproofing to protect your home.",
    icon:
      "https://images.unsplash.com/photo-1581094288338-42d22774fe02?auto=format&fit=crop&w=80",
  },
  {
    id: 3,
    title: "Gutter Services",
    description:
      "Gutter cleaning, installation, and maintenance to protect your foundation.",
    icon:
      "https://images.unsplash.com/photo-1581093800431-361c7d4d3e39?auto=format&fit=crop&w=80",
  },
  {
    id: 4,
    title: "Storm Damage Repair",
    description:
      "Fast storm restoration including insurance assistance and emergency fixes.",
    icon:
      "https://images.unsplash.com/photo-1600195077905-cc6147b3cb62?auto=format&fit=crop&w=80",
  },
];

export default servicesData;